import { Component, OnInit, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NutzerService } from 'src/app/service/nutzer.service';
import { INutzer } from 'src/app/models/INutzer.interface';
import { SessionService } from 'src/app/service/session.service';
import {NgbDateStruct, NgbDate, NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Rolle } from 'src/app/models/Rolle.enum';
import { Gender } from 'src/app/models/gender.enum';
import * as sha1 from 'js-sha1';
import * as QRCode from 'qrcode';
import { TimePickerService } from 'src/app/service/time-picker-service.service';
import { IPasskey } from 'src/app/models/IPasskey.interface';
import { isWebAuthnSupported } from 'src/app/utils/webauthn';

@Component({
  selector: 'app-view-user-settings',
  templateUrl: './view-user-settings.component.html',
  styleUrls: ['./view-user-settings.component.scss']
})
export class ViewUserSettingsComponent implements OnInit {



  private _gebDate: NgbDateStruct;
  public showDelete: boolean = false;
  public currentUser: INutzer;
  public currentRolle: String;
  @Input() public echterNutzer?: INutzer;
  public nutzer: INutzer;
  public Rolle = Rolle;
  public Gender = Gender;
  public Object = Object;
  public pw1 = "";
  public pw2 = "";
  public passwordCheckVisible: boolean;
  public passwordValid: boolean;
  public mfaMethode: 'NONE' | 'MAIL' | 'TOTP' = 'NONE';
  public totpSetup: {secret: string, qrDataUrl: string} | null = null;
  public totpCode = "";
  /** Zweiter Faktor ist per SU-Einstellung verpflichtend, "Keiner" ist dann nicht mehr wählbar */
  public mfaPflicht = false;
  public passkeys: IPasskey[] = [];
  public newPasskeyName = "";
  public passkeySupported = isWebAuthnSupported();
  public passkeyBusy = false;

  constructor(
    private toast: ToastrService,
    private nutzerServcie: NutzerService,
    private timePickerService: TimePickerService,
    private sessionService: SessionService,
    private activeDialog: NgbModal
  ) {
    this.currentUser = this.sessionService.session.nutzer;
    this.currentRolle = this.currentUser.rolle;
  }

  ngOnInit() {
    this.nutzer = Object.assign({}, this.nutzerServcie.getNutzer(this.echterNutzer.id));
    this.mfaMethode = this.nutzer.mfa_methode || 'NONE';
    if (this.currentUser.id === this.nutzer.id) {
      this.loadPasskeys();
      this.nutzerServcie.getMfaPflicht().then(pflicht => this.mfaPflicht = pflicht).catch(error => console.log(error));
    }
  }

  public async loadPasskeys() {
    try {
      this.passkeys = await this.nutzerServcie.getPasskeys();
    } catch (error) {
      console.log(error);
    }
  }

  public async addPasskey() {
    if (this.passkeyBusy) {
      return;
    }
    this.passkeyBusy = true;
    try {
      const msg = await this.nutzerServcie.registerPasskey(this.newPasskeyName);
      this.newPasskeyName = "";
      this.toast.success(msg, "Erfolgreich");
      await this.loadPasskeys();
    } catch (error) {
      if (!error || error.name !== 'NotAllowedError') {
        // NotAllowedError = Nutzer hat den Browser-Dialog abgebrochen
        this.toast.error(typeof error === 'string' ? error : "Der Passkey konnte nicht eingerichtet werden", "Fehler");
      }
    } finally {
      this.passkeyBusy = false;
    }
  }

  public async deletePasskey(passkey: IPasskey) {
    try {
      const msg = await this.nutzerServcie.deletePasskey(passkey.id);
      this.toast.success(msg, "Erfolgreich");
      await this.loadPasskeys();
    } catch (error) {
      this.toast.error(error, "Fehler");
    }
  }

  public async onMfaMethodeChange() {
    if (this.mfaMethode === 'TOTP' && this.nutzer.mfa_methode !== 'TOTP') {
      await this.startTotpSetup();
    } else {
      this.totpSetup = null;
    }
  }

  public async startTotpSetup() {
    try {
      const setup = await this.nutzerServcie.startTotpSetup();
      const qrDataUrl = await QRCode.toDataURL(setup.otpauthUrl);
      this.totpSetup = {secret: setup.secret, qrDataUrl: qrDataUrl};
      this.totpCode = "";
    } catch (error) {
      this.toast.error(error, "Fehler");
      this.mfaMethode = this.nutzer.mfa_methode || 'NONE';
    }
  }

  public async activateTotp() {
    if (!this.totpCode) {
      this.toast.error("Bitte den Code aus der Authenticator-App eingeben", "Fehler");
      return;
    }
    try {
      const msg = await this.nutzerServcie.activateTotp(this.totpCode);
      this.nutzer.mfa_methode = 'TOTP';
      this.totpSetup = null;
      this.totpCode = "";
      this.toast.success(msg, "Erfolgreich");
    } catch (error) {
      this.toast.error(error, "Fehler");
    }
  }

  public async saveMfaMethode() {
    if (this.mfaMethode === 'TOTP') {
      return;
    }
    try {
      const msg = await this.nutzerServcie.setMfaMethode(this.mfaMethode);
      this.nutzer.mfa_methode = this.mfaMethode;
      this.toast.success(msg, "Erfolgreich");
    } catch (error) {
      this.toast.error(error, "Fehler");
    }
  }

  /** SU/ADM: zweiten Faktor eines anderen Nutzers auf E-Mail zurücksetzen */
  public async resetMfa() {
    try {
      const msg = await this.nutzerServcie.resetMfaToMail(this.nutzer);
      this.nutzer.mfa_methode = 'MAIL';
      this.toast.success(msg, "Erfolgreich");
    } catch (error) {
      this.toast.error(error, "Fehler");
    }
  }

  public async delete() {
    try{
      await this.nutzerServcie.deleteNutzer(this.nutzer);
      this.toast.success("Nutzer erfolgreich gelöscht", "Erfolgreich");
      if(this.nutzer.id === this.sessionService.session.nutzer.id){
        this.sessionService.logout();
        location.reload();
      }
    } catch (error) {
      this.toast.error(error, "Fehler beim Löschen");
    }
  }

  public async saveData(type: number) {
    switch (type) {
      case 0:
        this.nutzerServcie.updateNutzerBasics(this.nutzer).
          then(msg => {
            this.toast.success(msg, "Erfolgreich");
            this.activeDialog.dismissAll()}).
          catch(msg => this.toast.error(msg, "Fehler"));
        break;
      case 1:
        if (this.pw1 !== this.pw2) {
          this.toast.error("Passwörter sind nicht gleich", "Fehler");
          return;
        }
        if (this.pw1 && !this.passwordValid) {
          this.toast.error("Passwort entspricht nicht den Sicherheitsanforderungen", "Fehler");
          return;
        }
        if (this.pw1) {
          this.nutzer.passworthash = sha1(this.pw1);
        }
        this.nutzerServcie.updateNutzerCredentials(this.nutzer).
          then(msg => {
          this.toast.success(msg, "Erfolgreich");
          this.activeDialog.dismissAll();
        }).
          catch(msg => this.toast.error(msg, "Fehler"));
        break;
      default:
        this.toast.error("Fehler beim speichern", "Fehler");
        break;
    }
  }

  public set gebDate(newDate: NgbDateStruct) {
    this._gebDate = newDate;
    this.nutzer.geburtsdatum = this.timePickerService.structToDate(newDate);
  }

  public get gebDate(): NgbDateStruct {
    if (!this._gebDate) {
      this._gebDate = this.timePickerService.dateToStruct(this.nutzer.geburtsdatum);
    }

    return this._gebDate;
  }
  public async close(){
    this.activeDialog.dismissAll();
  }

  public isDialog():boolean{
    return this.activeDialog.hasOpenModals();
  }
}
